import { styled } from '@teko/ds-mobile';
import { NavBar } from '@teko/teko-ecommerce';
import { ThemeProps } from '@teko/ui';
import { Address } from '@teko/user';
import { MobileLayout } from 'components/Layout/MobileLayout';
import { AddressForm as AddressBookForm } from 'components/mobile/organisms';
import { MODE_TERMINAL_PICKER, useDistanceTerminalContext } from 'contexts';
import { t } from 'i18n';
import { useGetDistanceTerminal } from '../useGetDistanceTerminal';

export const ModeEnterAddress = () => {
  const {
    temporaryDataDistanceTerminal,
    setTemporaryDataDistanceTerminal,
    editingAddress,
    setModeTerminalPicker,
    location,
    resetSelectedAddress,
  } = useDistanceTerminalContext();
  const { getDistanceTerminalsByAddress } = useGetDistanceTerminal();

  const addressId = !editingAddress ? undefined : editingAddress.addressId;

  const handleSaveAddress = async (addr: Address) => {
    const isUpdatingAddress = !!addressId;
    setTemporaryDataDistanceTerminal?.({
      ...temporaryDataDistanceTerminal,
      location: {
        address: addr.address || '',
        provinceName: addr.provinceName || '',
        wardName: addr.wardName || '',
        provinceCode: addr.provinceCode,
        wardCode: addr.wardCode,
        districtCode: addr.districtCode,
        districtName: addr.districtName,
        addressId: addr.addressId,
        addressNote: addr.addressNote || addr.note || '',
        lat: addr.latitude ? Number(addr.latitude) : undefined,
        long: addr.longitude ? Number(addr.longitude) : undefined,
      },
    });
    if (isUpdatingAddress) {
      if (location?.addressId === addr.addressId) {
        resetSelectedAddress?.();
      } else {
        setModeTerminalPicker(MODE_TERMINAL_PICKER.LIST_ADDRESS);
      }
      return;
    }
    getDistanceTerminalsByAddress({
      address: addr.address || '',
      provinceName: addr.provinceName || '',
      wardName: addr.wardName || '',
      provinceCode: addr.provinceCode,
      wardCode: addr.wardCode,
      districtCode: addr.districtCode,
      districtName: addr.districtName,
      addressId: addr.addressId,
      addressNote: addr.addressNote || addr.note || '',
      lat: addr.latitude ? Number(addr.latitude) : undefined,
      long: addr.longitude ? Number(addr.longitude) : undefined,
    });
  };

  return (
    <MobileLayout
      navbar={
        <NavBar
          title={
            editingAddress ? t('Chỉnh sửa địa chỉ') : t('Thêm mới địa chỉ')
          }
          goBack={() =>
            setModeTerminalPicker(MODE_TERMINAL_PICKER.LIST_ADDRESS)
          }
        />
      }
    >
      <AddressBookForm editingAddress={addressId} onClose={handleSaveAddress} />
    </MobileLayout>
  );
};

export const SuggestWrapper = styled.div`
  background-color: #fafafa;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: scroll;
`;

export const ItemSuggestion = styled.div`
  padding: 8px 10px;
  cursor: pointer;
`;

export const Spinner = styled.div<ThemeProps>(
  ({ theme }) => `
  border: 3px solid ${theme.colors.blue100};
  border-top-color: ${theme.colors.blue500};
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  margin: 0 0.5rem;
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`,
);
